import { render, staticRenderFns } from "./lvxing.vue?vue&type=template&id=14e98670&scoped=true&"
import script from "./lvxing.vue?vue&type=script&lang=js&"
export * from "./lvxing.vue?vue&type=script&lang=js&"
import style0 from "./lvxing.vue?vue&type=style&index=0&id=14e98670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e98670",
  null
  
)

export default component.exports